module.exports = __webpack_public_path__ + "14e28e4b1a7e827a1440225efecbfbc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-retention.png
// module id = 605
// module chunks = 0